import React, { useEffect } from 'react';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import {
  PageContainer,
  MainContent,
  Container,
  ContentSection,
  HeaderSection,
  Title,
  Subtitle,
  ContentWrapper,
  Section,
  SectionTitle,
  SectionContent,
  Paragraph,
  List,
  ListItem,
} from './Terms.styled';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fadeIn = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  return (
    <PageContainer>
      <Header />

      <MainContent>
        <ContentSection>
          <Container>
            <ContentWrapper
              initial="hidden"
              animate="visible"
              variants={staggerContainer}
            >
              <HeaderSection>
                <Title variants={fadeIn}>Terms & Conditions</Title>
                <Subtitle variants={fadeIn}>
                  Please read these terms carefully before using our website or
                  services.
                </Subtitle>
              </HeaderSection>

              <Section variants={fadeIn}>
                <SectionTitle data-number="1">Use of Website</SectionTitle>
                <SectionContent>
                  <List>
                    <ListItem>
                      The content on this site is for general information about
                      our products and services.
                    </ListItem>
                    <ListItem>
                      You agree to use this site only for lawful purposes and in
                      a way that does not harm our reputation or interfere with
                      the website's operation.
                    </ListItem>
                  </List>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="2">Product Information</SectionTitle>
                <SectionContent>
                  <List>
                    <ListItem>
                      We strive to provide accurate and up-to-date product
                      details, but specifications, pricing, and availability
                      may change without notice.
                    </ListItem>
                    <ListItem>
                      All images are for representation purposes only.
                    </ListItem>
                  </List>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="3">Orders & Transactions</SectionTitle>
                <SectionContent>
                  <List>
                    <ListItem>
                      Orders placed via phone, email, or in person are subject
                      to confirmation and acceptance by us.
                    </ListItem>
                    <ListItem>
                      Payment terms will be as agreed upon in writing before
                      delivery.
                    </ListItem>
                  </List>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="4">Intellectual Property</SectionTitle>
                <SectionContent>
                  <Paragraph>
                    All content, logos, designs, text, graphics, and product
                    images on this website are owned by Swan Pipe Support Pvt.
                    Ltd. and protected by applicable laws.
                  </Paragraph>
                  <Paragraph>
                    You may not copy, reproduce, or distribute our content
                    without prior written permission.
                  </Paragraph>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="5">Limitation of Liability</SectionTitle>
                <SectionContent>
                  <List>
                    <ListItem>
                      We are not responsible for any loss or damage arising from
                      the use of our website or products, except as required by
                      law.
                    </ListItem>
                    <ListItem>
                      We are not liable for downtime, errors, or interruptions
                      of this website.
                    </ListItem>
                  </List>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="6">Links to Other Websites</SectionTitle>
                <SectionContent>
                  <Paragraph>
                    Our website may contain links to third-party sites. We are
                    not responsible for the content, privacy policies, or
                    practices of these websites.
                  </Paragraph>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="7">Changes to Terms</SectionTitle>
                <SectionContent>
                  <Paragraph>
                    We may update these Terms & Conditions at any time. The
                    revised terms will be posted on this page with an updated
                    date.
                  </Paragraph>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="8">Governing Law</SectionTitle>
                <SectionContent>
                  <Paragraph>
                    These Terms & Conditions are governed by the laws of India,
                    and any disputes will be subject to the courts in Madurai,
                    Tamil Nadu.
                  </Paragraph>
                </SectionContent>
              </Section>
            </ContentWrapper>
          </Container>
        </ContentSection>
      </MainContent>

      <Footer />
    </PageContainer>
  );
};

export default Terms;

